export const WALKS = {
  walk4: ["しっかり", "歩行"],
  walk3: ["せいかつ", "歩行"],
  walk2: ["立位・座位"],
  walk1: ["横に", "なっている"],
};
export const WALKS_BAR_KEYS = ["walk4", "walk3", "walk2", "walk1"];
export const WALKS_LINE_KEYS = ["walk1", "walk2", "walk3", "walk4"];
export const WALKS_BAR_FOR_HOME_KEYS = ["walk4", "walk3", "walk2"];

export const EMPTY_WORK_CHARACTER = "---";

export const MIN_X_SPEED = 40;
export const MIN_X_PITCH = 60;
export const MIN_X_METSH = 20;
